module.exports = __webpack_public_path__ + "img/5.b1b59ea5.png";